export default "__VITE_ASSET__5850bba3__"